import { FieldProps } from "./types";

export default function Field({ label, hint, required, error, children }: FieldProps) {
    return (
        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
            <div style={{ display: "flex", alignItems: "baseline", gap: 8 }}>
                <label style={{ fontSize: 12, fontWeight: 600, color: "var(--text2)", letterSpacing: "0.5px", textTransform: "uppercase" }}>
                    {label}{required && <span style={{ color: "var(--or)", marginLeft: 3 }}>*</span>}
                </label>
                {hint && <span style={{ fontSize: 11, color: "var(--text3)" }}>{hint}</span>}
            </div>
            {children}
            {error && <span style={{ fontSize: 12, color: "var(--red, #e05252)" }}>{error}</span>}
        </div>
    );
}